import { LucideSearch } from "lucide-react";
import { Input } from "../ui/Input";
import { useIconRepo } from "../../data/icons";

export const InlineSearchBar = (props: any) => {
    const repo = useIconRepo();
    const totalIcons = repo.repository.map(p => p.icons.length).reduce((accum, v) => accum + v, 0);

    return (
        <div className="hidden md:flex relative items-center max-w-[560px] w-1/2">

            <LucideSearch
                size="18px"
                className="text-lg text-surface-300  absolute left-4 pointer-events-none"
            />

            <Input
                intent="primary"
                inputSize="large"
                type="search"
                placeholder={`Search all ${totalIcons} icons...`}
            />

        </div>
    );
};
